import type { ReactNode } from "react";

import { useAuth } from "@/lib/auth/auth-context";
import { hasCapabilities, type Capability } from "@/lib/auth/roles";

import { Forbidden } from "@/routes/forbidden";

/**
 * Role/capability guard. Renders children only if the current user satisfies
 * every required capability; otherwise shows the Forbidden screen. Assumes an
 * authenticated context (mount inside the authed layout) — capability checks
 * read the backend-computed permission booleans (see lib/auth/roles.ts).
 */
export function RequireCapability({
  required,
  children,
}: {
  required: readonly Capability[];
  children: ReactNode;
}) {
  const { user } = useAuth();
  if (!hasCapabilities(user, required)) {
    return <Forbidden />;
  }
  return <>{children}</>;
}
